var _path, _path2, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletsGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 76,
    viewBox: "0 0 208 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.677 8.5V9.20605H205.383V9.91211H206.088V10.6172H206.794V11.3232H207.5V52.6768H206.794V53.3828H206.088V54.0879H205.383V54.7939H204.677V55.5H163.323V54.7939H162.617V54.0879H161.912V53.3828H161.206V52.6768H160.5V11.3232H161.206V10.6172H161.912V9.91211H162.617V9.20605H163.323V8.5H204.677Z",
    fill: "#26261E",
    stroke: "#FCFF62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.329 25.2628C179.222 19.527 188.778 19.527 194.672 25.2628L195.381 25.9531C195.676 26.2399 195.676 26.7049 195.381 26.9916L192.955 29.3531C192.807 29.4965 192.569 29.4965 192.421 29.3531L191.445 28.4032C187.334 24.4017 180.667 24.4017 176.555 28.4032L175.51 29.4204C175.363 29.5639 175.124 29.5639 174.976 29.4204L172.55 27.0591C172.255 26.7722 172.255 26.3072 172.55 26.0205L173.329 25.2628ZM199.69 30.1465L201.85 32.248C202.145 32.5349 202.145 33 201.85 33.2867L192.112 42.7634C191.818 43.0502 191.34 43.0502 191.045 42.7634L184.134 36.0375C184.06 35.9658 183.941 35.9658 183.867 36.0375L176.956 42.7634C176.661 43.0502 176.183 43.0502 175.889 42.7634L166.151 33.2867C165.856 32.9998 165.856 32.5348 166.151 32.248L168.31 30.1464C168.605 29.8596 169.083 29.8596 169.377 30.1464L176.289 36.8723C176.362 36.9441 176.482 36.9441 176.556 36.8723L183.467 30.1464C183.761 29.8596 184.239 29.8596 184.534 30.1464L191.445 36.8723C191.519 36.9441 191.638 36.9441 191.712 36.8723L198.623 30.1465C198.918 29.8596 199.396 29.8596 199.69 30.1465Z",
    fill: "#3396FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3142_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.677 20.5V21.2061H165.383V21.9121H166.088V22.6172H166.794V23.3232H167.5V64.6768H166.794V65.3828H166.088V66.0879H165.383V66.7939H164.677V67.5H123.323V66.7939H122.617V66.0879H121.912V65.3828H121.206V64.6768H120.5V23.3232H121.206V22.6172H121.912V21.9121H122.617V21.2061H123.323V20.5H164.677Z",
    fill: "#26261E",
    stroke: "#FCFF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.294 36.5881C131.294 33.6642 133.664 31.2939 136.588 31.2939H151.412C154.335 31.2939 156.706 33.6642 156.706 36.5881V51.4116C156.706 54.3355 154.335 56.7057 151.412 56.7057H136.588C133.664 56.7057 131.294 54.3355 131.294 51.4116V36.5881Z",
    fill: "url(#paint0_linear_3142_5179)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.068 37.6465C141.212 37.666 141.355 37.6877 141.499 37.7046C143.137 37.8964 144.49 38.6281 145.569 39.8684C146.324 40.7369 146.8 41.747 146.991 42.8806C147.231 44.3127 147.018 45.6808 146.333 46.9671C146.135 47.3393 145.734 47.5526 145.351 47.5059C144.921 47.4535 144.588 47.167 144.483 46.7513C144.415 46.4868 144.46 46.2369 144.588 45.9966C144.932 45.3526 145.105 44.6612 145.093 43.9337C145.061 41.7891 143.519 40.1017 141.587 39.7348C139.614 39.3598 137.724 40.3884 136.908 42.0842C136.552 42.824 136.417 43.6076 136.503 44.4288C136.592 45.2733 136.902 46.0264 137.436 46.6814C138.108 47.5049 138.969 48.0159 140.016 48.2139C140.505 48.3063 140.997 48.2869 141.488 48.2872C144.501 48.2891 147.513 48.2884 150.526 48.2873C150.97 48.2872 151.367 47.9819 151.492 47.5531C151.682 46.8996 151.199 46.2494 150.518 46.2418C150.021 46.2362 149.586 45.8696 149.523 45.4032C149.452 44.8789 149.751 44.4074 150.247 44.2796C150.4 44.2403 150.564 44.2467 150.719 44.2138C151.129 44.127 151.453 43.7946 151.516 43.4109C151.587 42.9756 151.407 42.5662 151.049 42.3446C150.681 42.1177 150.236 42.1318 149.89 42.4C149.621 42.6085 149.325 42.6801 149 42.6019C148.609 42.5075 148.355 42.2494 148.272 41.8597C148.189 41.471 148.291 41.1206 148.613 40.8622C149.085 40.4838 149.622 40.27 150.226 40.2077C151.019 40.1259 151.725 40.3355 152.351 40.8158C153.012 41.3222 153.388 42.0007 153.496 42.8228C153.611 43.6912 153.379 44.4665 152.829 45.1451C152.769 45.2187 152.768 45.2606 152.829 45.3344C153.355 45.9725 153.589 46.7123 153.515 47.5318C153.394 48.8873 152.421 49.9349 151.166 50.2124C150.942 50.2619 150.709 50.2876 150.479 50.2879C147.214 50.2927 143.949 50.3007 140.684 50.2868C139.212 50.2806 137.898 49.7942 136.762 48.8503C135.659 47.9346 134.942 46.7768 134.622 45.3779C134.456 44.6535 134.43 43.9223 134.524 43.1834C134.669 42.0448 135.082 41.0173 135.788 40.1166C136.793 38.8347 138.096 38.0344 139.707 37.7558C139.926 37.718 140.149 37.705 140.369 37.6782C140.409 37.6733 140.448 37.6573 140.487 37.6465H141.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 137.646,
    cy: 46.6464,
    rx: 4.23529,
    ry: 4.23529,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 151.995,
    cy: 40.5583,
    rx: 1.42941,
    ry: 1.42941,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3142_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.677 8.5V9.20605H125.383V9.91211H126.088V10.6172H126.794V11.3232H127.5V52.6768H126.794V53.3828H126.088V54.0879H125.383V54.7939H124.677V55.5H83.3232V54.7939H82.6172V54.0879H81.9121V53.3828H81.2061V52.6768H80.5V11.3232H81.2061V10.6172H81.9121V9.91211H82.6172V9.20605H83.3232V8.5H124.677Z",
    fill: "#26261E",
    stroke: "#FCFF62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.705 44.7057H93.2952C92.1899 44.7057 91.2939 43.8097 91.2939 42.7045V21.2952C91.2939 20.1899 92.1899 19.2939 93.2952 19.2939H114.705C115.81 19.2939 116.706 20.1899 116.706 21.2952V42.7045C116.706 43.8097 115.81 44.7057 114.705 44.7057Z",
    fill: "#1F2B2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.705 44.7057H93.2952C92.1899 44.7057 91.2939 43.8097 91.2939 42.7045V21.2952C91.2939 20.1899 92.1899 19.2939 93.2952 19.2939H114.705C115.81 19.2939 116.706 20.1899 116.706 21.2952V42.7045C116.706 43.8097 115.81 44.7057 114.705 44.7057Z",
    fill: "#121A1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.936 35.9509L98.7032 31.7597L100.807 29.6769L102.936 31.7851L105.065 29.6769L107.168 31.7597L102.936 35.9509ZM113.53 25.4603L111.426 23.3774L109.297 25.4856L107.168 23.3774L105.039 25.4856L102.936 23.4028L94.4707 31.7851L102.936 40.1674L111.401 31.7851L109.271 29.6769L113.53 25.4603Z",
    fill: "#4CFFB3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3142_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6768 20.5V21.2061H85.3828V21.9121H86.0879V22.6172H86.7939V23.3232H87.5V64.6768H86.7939V65.3828H86.0879V66.0879H85.3828V66.7939H84.6768V67.5H43.3232V66.7939H42.6172V66.0879H41.9121V65.3828H41.2061V64.6768H40.5V23.3232H41.2061V22.6172H41.9121V21.9121H42.6172V21.2061H43.3232V20.5H84.6768Z",
    fill: "#26261E",
    stroke: "#FCFF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2939 36.5881C51.2939 33.6642 53.6642 31.2939 56.5881 31.2939H71.4116C74.3355 31.2939 76.7057 33.6642 76.7057 36.5881V51.4116C76.7057 54.3355 74.3355 56.7057 71.4116 56.7057H56.5881C53.6642 56.7057 51.2939 54.3355 51.2939 51.4116V36.5881Z",
    fill: "url(#paint1_linear_3142_5179)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9549 35.5293L56.8859 38.485L63.0188 41.1849L72.0597 38.2123L65.9549 35.5293ZM56.5889 38.7489L62.7772 41.4318V52.4704L56.5889 49.7875V38.7489ZM65.7877 47.3345V40.5802L72.2269 38.4592V49.6342L65.7877 47.3345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2624 53.5366C75.4439 55.4027 73.5801 56.7061 71.4118 56.7061H56.5883C54.9413 56.7061 53.47 55.9541 52.499 54.7746C52.8254 53.8622 53.6427 53.1633 54.67 53.0372L73.254 50.7554C74.705 50.5772 76.0258 51.6091 76.2039 53.0601L76.2624 53.5366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0718 53.9246C75.177 55.5806 73.4254 56.7056 71.4111 56.7056H56.5875C54.5732 56.7056 52.8216 55.5806 51.9268 53.9246C52.3089 53.5491 52.8329 53.3174 53.4111 53.3174H74.5875C75.1657 53.3174 75.6897 53.5491 76.0718 53.9246Z",
    fill: "#CDF5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2121 38.3878C55.2121 38.0954 54.9751 37.8584 54.6827 37.8584C54.3903 37.8584 54.1533 38.0954 54.1533 38.3878V45.0584C54.1533 46.5203 55.3384 47.7055 56.8004 47.7055H58.918C60.38 47.7055 61.5651 46.5203 61.5651 45.0584V41.8819C61.5651 41.5895 61.3281 41.3525 61.0357 41.3525C60.7433 41.3525 60.5063 41.5895 60.5063 41.8819V45.0584C60.5063 45.9356 59.7952 46.6466 58.918 46.6466H56.8004C55.9232 46.6466 55.2121 45.9356 55.2121 45.0584V38.3878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0358 40.7172C61.5036 40.7172 61.8828 40.338 61.8828 39.8702C61.8828 39.4024 61.5036 39.0231 61.0358 39.0231C60.5679 39.0231 60.1887 39.4024 60.1887 39.8702C60.1887 40.338 60.5679 40.7172 61.0358 40.7172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6239 44.2114C62.6239 42.7494 63.809 41.5643 65.271 41.5643C66.7329 41.5643 67.918 42.7494 67.918 44.2114V47.1761C67.918 47.4685 67.681 47.7055 67.3886 47.7055C67.0962 47.7055 66.8592 47.4685 66.8592 47.1761V44.2114C66.8592 43.3342 66.1481 42.6231 65.271 42.6231C64.3938 42.6231 63.6827 43.3342 63.6827 44.2114V47.1761C63.6827 47.4685 63.4457 47.7055 63.1533 47.7055C62.8609 47.7055 62.6239 47.4685 62.6239 47.1761V44.2114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8357 42.6231C70.7247 42.6231 69.824 43.5238 69.824 44.6349C69.824 45.746 70.7247 46.6467 71.8357 46.6467C72.3513 46.6467 72.8205 46.4534 73.1768 46.1345C73.3946 45.9395 73.7293 45.9581 73.9243 46.1759C74.1193 46.3938 74.1008 46.7285 73.8829 46.9235C73.34 47.4094 72.6218 47.7055 71.8357 47.7055C70.1399 47.7055 68.7651 46.3307 68.7651 44.6349C68.7651 42.9391 70.1399 41.5643 71.8357 41.5643C73.5316 41.5643 74.9063 42.9391 74.9063 44.6349C74.9063 44.8513 74.7764 45.0374 74.5904 45.1195C74.5251 45.1483 74.4529 45.1643 74.3769 45.1643L74.3743 45.1643H72.5769C72.2845 45.1643 72.0475 44.9273 72.0475 44.6349C72.0475 44.3425 72.2845 44.1055 72.5769 44.1055H73.7771C73.5447 43.2513 72.7636 42.6231 71.8357 42.6231Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3142_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6768 8.5V9.20605H45.3828V9.91211H46.0879V10.6172H46.7939V11.3232H47.5V52.6768H46.7939V53.3828H46.0879V54.0879H45.3828V54.7939H44.6768V55.5H3.32324V54.7939H2.61719V54.0879H1.91211V53.3828H1.20605V52.6768H0.5V11.3232H1.20605V10.6172H1.91211V9.91211H2.61719V9.20605H3.32324V8.5H44.6768Z",
    fill: "#26261E",
    stroke: "#FCFF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4706 19.4355L25.875 27.2755L27.8454 22.6551L36.4706 19.4355Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 19.4355L22.5325 27.3487L20.6565 22.6551L12.0312 19.4355Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6551 37.6133L29.8359 41.92L35.8726 43.5821L37.6019 37.7074L32.6551 37.6133Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9092 37.7074L12.6279 43.5821L18.6541 41.92L15.8454 37.6133L10.9092 37.7074Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3292 30.3382L16.6523 32.8679L22.6261 33.1397L22.427 26.7109L18.3292 30.3382Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1718 30.3381L26.0112 26.6377L25.875 33.1396L31.8487 32.8678L30.1718 30.3381Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6543 41.9199L22.27 40.1742L19.1573 37.749L18.6543 41.9199Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2314 40.1742L29.8365 41.9199L29.344 37.749L26.2314 40.1742Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8365 41.9205L26.2314 40.1748L26.5248 42.5164L26.4933 43.5094L29.8365 41.9205Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6543 41.9205L22.0079 43.5094L21.987 42.5164L22.27 40.1748L18.6543 41.9205Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0706 36.2023L19.0732 35.3243L21.1902 34.3521L22.0706 36.2023Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4297 36.2023L27.3101 34.3521L29.4376 35.3243L26.4297 36.2023Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6544 41.92L19.1785 37.6133L15.8457 37.7074L18.6544 41.92Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3232 37.6133L29.8367 41.92L32.6559 37.7074L29.3232 37.6133Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8487 32.8677L25.875 33.1394L26.4304 36.2024L27.3108 34.3521L29.4383 35.3243L31.8487 32.8677Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0732 35.3243L21.1903 34.3521L22.0707 36.2024L22.6261 33.1394L16.6523 32.8677L19.0732 35.3243Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6523 32.8677L19.1571 37.7494L19.0732 35.3243L16.6523 32.8677Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4381 35.3243L29.3438 37.7494L31.8485 32.8677L29.4381 35.3243Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6258 33.1396L22.0703 36.2026L22.7725 39.8194L22.9298 35.0527L22.6258 33.1396Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8746 33.1396L25.5811 35.0423L25.7279 39.8194L26.4299 36.2026L25.8746 33.1396Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4307 36.2023L25.7285 39.8191L26.2317 40.1746L29.3443 37.7495L29.4386 35.3242L26.4307 36.2023Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0732 35.3242L19.1571 37.7495L22.2696 40.1746L22.7728 39.8191L22.0706 36.2023L19.0732 35.3242Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4935 43.5094L26.5249 42.5162L26.2524 42.2862H22.2491L21.987 42.5162L22.0079 43.5094L18.6543 41.9204L19.828 42.8821L22.2071 44.5233H26.2839L28.6733 42.8821L29.8366 41.9204L26.4935 43.5094Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2318 40.1747L25.7286 39.8193H22.7732L22.2702 40.1747L21.9873 42.5162L22.2493 42.2863H26.2527L26.5253 42.5162L26.2318 40.1747Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9212 27.7877L37.812 23.4601L36.4705 19.4355L26.2314 27.0142L30.172 30.3384L35.737 31.9586L36.9631 30.5265L36.4288 30.1397L37.2775 29.3662L36.6278 28.8645L37.4767 28.2163L36.9212 27.7877Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6885 23.4601L11.5898 27.7877L11.0134 28.2163L11.8727 28.8645L11.223 29.3662L12.0719 30.1397L11.5374 30.5265L12.7636 31.9586L18.3286 30.3384L22.2691 27.0142L12.0299 19.4355L10.6885 23.4601Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7366 31.958L30.1718 30.3379L31.8485 32.8675L29.3438 37.7492L32.6555 37.7074H37.6021L35.7366 31.958Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3291 30.3379L12.7642 31.958L10.9092 37.7074H15.8454L19.1571 37.7492L16.6524 32.8675L18.3291 30.3379Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8744 33.1394L26.2308 27.0137L27.8447 22.6548H20.6553L22.2692 27.0137L22.6255 33.1394L22.7618 35.0628L22.7722 39.8192H25.7277L25.7382 35.0628L25.8744 33.1394Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.285714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3142_5179",
    x: 120,
    y: 12,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3142_5179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3142_5179",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3142_5179",
    x: 80,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3142_5179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3142_5179",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3142_5179",
    x: 40,
    y: 12,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3142_5179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3142_5179",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3142_5179",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3142_5179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3142_5179",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3142_5179",
    x1: 144,
    y1: 31.2939,
    x2: 144,
    y2: 56.7057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3142_5179",
    x1: 63.9998,
    y1: 31.2939,
    x2: 63.9998,
    y2: 56.7057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09CCAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BDDCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletsGroup);
export default __webpack_public_path__ + "static/media/WalletsGroup.3bf4cc763fdf3ac5abe2f1d8751988a9.svg";
export { ForwardRef as ReactComponent };